/* eslint-disable max-len */

export default {
    name       : 'flyingOperations',
    /**
     * @override
     */
    data() {
        return {
            uuid: null,
            relatedOperations: []
        };
    },
    props: {
        id: {
            type: String,
            required: false
        },
        previousOperations: {
            type: Array,
            required: true
        }
    },
    watch: {
        previousOperations: {
          handler() {
            this.operations();
          },
          deep: true,
          immediate: true
        }
    },
      
    methods: {
        /**
         * Obtenemos la información relativa a las operaciones del interviniente
         */
        operations() {
            const processed = this.previousOperations.map(operation => {
                switch (operation.amount_shares_indicator) {
                    case 'I':
                        operation.amount = `${this.$options.filters.yuriCurrency(operation.net_amount)} (Neto)`;
                    break;
                    case 'P':
                        operation.amount = `${operation.shares} (Participaciones)`;
                    break;
                    case 'B':
                    default:
                        operation.amount = operation.is_total_redemption
                        ? 'Total'
                        : `${this.$options.filters.yuriCurrency(operation.gross_amount)} (Bruto)`;
                    break;
                }
              return operation;
            });
            this.relatedOperations.items = processed;
        }
          
    },

    /**
     * @override
     */
    beforeMount() {
        this.relatedOperations = {
          fields: [
            { key: 'request_date', label: 'Solicitud' },
            { key: 'id_object', label: 'Operación', class: 'operation_code' },
            { key: 'key_operation_type', label: 'Tipo de operación' },
            { key: 'expires_on', label: 'Fecha límite' },
            { key: 'operation_status', label: 'Estado', class: 'operation_status' },
            { key: 'amount', label: 'Importe' }
          ],
          items: []
        };
        this.operations();
    }     
};
